export interface MeetingParticipantModel {
    id: number;
    meetingId: number;
    name: string;
    textLength: number;
}
